var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 38.276C16 34.799 18.676 32 22 32C25.324 32 28 34.799 28 38.276V53.724C28 57.2008 25.324 60 22 60C18.676 60 16 57.2008 16 53.724V38.276Z",
    fill: "#E01E5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.276 44C34.7992 44 32 41.324 32 38C32 34.676 34.799 32 38.276 32H53.7244C57.2012 32 60.0004 34.676 60.0004 38C60.0004 41.324 57.2014 44 53.7244 44H38.276Z",
    fill: "#ECB22D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 6.276C32 2.799 34.676 0 38 0C41.324 0 44 2.799 44 6.276V21.724C44 25.201 41.324 28 38 28C34.676 28 32 25.201 32 21.724V6.276Z",
    fill: "#2FB67C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.276 28C2.799 28 0 25.324 0 22C0 18.676 2.799 16 6.276 16H21.724C25.201 16 28 18.676 28 22C28 25.324 25.201 28 21.724 28H6.276Z",
    fill: "#36C5F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 54C32 57.324 34.676 60 38 60C41.324 60 44 57.324 44 54C44 50.676 41.324 48 38 48H32V54Z",
    fill: "#ECB22D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 28H48V22C48 18.676 50.676 16 54 16C57.324 16 60 18.676 60 22C60 25.324 57.324 28 54 28Z",
    fill: "#2FB67C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 32H12V38C12 41.324 9.324 44 6 44C2.676 44 0 41.324 0 38C0 34.676 2.676 32 6 32Z",
    fill: "#E01E5A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 6V12H22C18.676 12 16 9.324 16 6C16 2.676 18.676 0 22 0C25.324 0 28 2.676 28 6Z",
    fill: "#36C5F1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.b1e34054ed26c5cb637b5060c9421e18.svg";
export { ForwardRef as ReactComponent };